import { render, staticRenderFns } from "./EditContractPage.vue?vue&type=template&id=7270af18&"
import script from "./EditContractPage.vue?vue&type=script&lang=js&"
export * from "./EditContractPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports